import utils from '@/utils';
import { clone } from '@/utils/dataUtil';
import { STRUCTURES_API } from '@/api';

const state = {
  tableKey: -999,
  currentTableRow: null,
  tableData: [],
  tableConfig: {
    columns: [{
      prop: 'versionId', label: 'Version', sortable: true,
    }, {
      prop: 'shortName', label: 'Name', sortable: true,
    }, {
      prop: 'description', label: 'Description', sortable: true,
    }, {
      prop: 'marketName', label: 'Market', sortable: true,
    }, {
      prop: 'createdBy', label: 'Created By', sortable: true,
    }, {
      prop: 'createdDate', label: 'Created Date', sortable: true, dataType: 'datetime',
    }, {
      prop: 'updatedBy', label: 'Updated By', sortable: true,
    }, {
      prop: 'updatedDate', label: 'Updated Date', sortable: true, dataType: 'datetime',
    }],
  },
  nullTableRow: {
    id: -999,
    versionId: null,
    shortName: null,
    description: null,
    commodityName: 'POWER',
    marketName: null,
    activeFlag: true,
    createdBy: null,
    createdDate: null,
    updatedBy: null,
    updatedDate: null,
  },
};

const getters = {
  getTableConfig: (state) => state.tableConfig,
  getTableData: (state) => state.tableData,
  getCurrentRow: (state) => state.currentTableRow,
  getMarketList: (state, getters, rootState) => rootState.lookup.marketList,
};

const actions = {
  initialize({ dispatch }) {
    dispatch('lookup/fetchMarketList', null, { root: true });
    dispatch('loadTableData');
  },
  resetTable({ dispatch, commit, state }) {
    commit('resetTable');
  },
  loadTableData({ commit }) {
    STRUCTURES_API.get('/market-record-types').then(({ data }) => {
      commit('loadTableData', data.marketRecordTypes);
      this.$notify(`${data.marketRecordTypes.length} Record Type(s) Loaded`, 'info');
    }).catch((err) => {
      this.$notify('Failed to Load Record Types', 'error');
    });
  },
  createTableRow({ commit }) {
    commit('createTableRow');
  },
  postMarketRecordType({ state }, reacordType) {
    STRUCTURES_API.post('/market-record-types', reacordType).then(({ data }) => {
      state.tableData.push(data);
      this.$notify('Record Type Added', 'success');
    }).catch((err) => {
      this.$notify('Failed to Add Record Type', 'error');
    });
  },
  updateMarketRecordType({ dispatch, commit, state }, marketRecordType) {
    STRUCTURES_API.put(`/market-record-types/${marketRecordType.id}`, marketRecordType).then(({ data }) => {
      commit('updateMarketRecordType', data);
      this.$notify('Record Type Updated', 'success');
    }).catch((err) => {
      this.$notify('Failed to Update Record Type', 'error');
    });
  },
  deleteTableRow({ dispatch, commit, state }) {
    STRUCTURES_API.delete(`/market-record-types/${state.currentTableRow.id}`).then(({ data }) => {
      commit('deleteTableRow');
      dispatch('currentTableRowChange', clone(state.nullTableRow));
      this.$notify('Record Type Removed', 'success');
    }).catch((err) => {
      this.$notify('Failed to Remove Record Type', 'error');
    });
  },
  currentTableRowChange({ commit }, currentTableRow) {
    commit('currentTableRowChange', currentTableRow);
  },
};

const mutations = {
  updateMarketRecordType(state, marketRecordType) {
    const rowIndex = state.tableData.findIndex(({ id }) => id === marketRecordType.id);
    state.tableData.splice(rowIndex, 1, marketRecordType);
  },
  currentTableRowChange(state, currentRow) {
    state.currentTableRow = currentRow;
  },
  resetTable(state) {
    state.tableData = [];
    state.currentTableRow = clone(state.nullTableRow);
  },
  loadTableData(state, marketRecordTypes) {
    state.tableData = marketRecordTypes;
  },
  createTableRow(state) {
    const marketRecordType = clone(state.nullTableRow);
    marketRecordType.id = state.tableKey++;
    marketRecordType.recordState = 1;
    marketRecordType.versionId = 1;
    marketRecordType.createdBy = this.getters['auth/getProfile'].userName;
    marketRecordType.createdDate = utils.date.getNow().utc().format();
    state.currentTableRow = marketRecordType;
  },
  deleteTableRow(state) {
    state.tableData = state.tableData.filter((marketRecordType) => marketRecordType.id !== state.currentTableRow.id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};